"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Body = exports.Header = exports.encode = exports.decode = void 0;
var b64_1 = __importDefault(require("./b64"));
var zlib_b64_1 = __importDefault(require("./zlib_b64"));
function decode(encoded, do_inflate) {
    if (do_inflate === void 0) { do_inflate = false; }
    return JSON.parse(do_inflate ? zlib_b64_1.default.decode(encoded) : b64_1.default.decode(encoded));
}
exports.decode = decode;
function encode(obj, do_deflate) {
    if (do_deflate === void 0) { do_deflate = false; }
    return (do_deflate ? zlib_b64_1.default.encode : b64_1.default.encode)(JSON.stringify(obj));
}
exports.encode = encode;
var Header = /** @class */ (function () {
    function Header(raw) {
        var d = decode(raw);
        this.typ = 'typ' in d ? d.typ : null;
        this.kid = 'kid' in d ? d.kid : null;
        this.alg = 'alg' in d ? d.alg : null;
        this.cmp = 'cmp' in d ? d.cmp : null;
    }
    /**
     * Will throw if the .typ attribute does not match desired value, and optionnaly
     * if it is missing too.
     * @param type The desired value for typ
     * @param required if a missing typ is acceptable
     */
    Header.prototype.typeMatches = function (type, required) {
        if (required === void 0) { required = false; }
        if (this.typ === null) {
            return required ? false : true;
        }
        if (this.typ.toUpperCase() === type.toUpperCase()) {
            return true;
        }
        return false;
    };
    return Header;
}());
exports.Header = Header;
var Body = /** @class */ (function () {
    function Body(raw) {
        this.all = typeof raw === 'string' ? decode(raw) : raw;
        this.iat = this.val('iat');
        this.sub = this.val('sub');
    }
    /**
     * Retrieve any other key from the body
     * @param key key of the attribute to retrieve
     */
    Body.prototype.val = function (key) {
        return key in this.all ? this.all[key] : null;
    };
    return Body;
}());
exports.Body = Body;
